import Http from '@/utils/http/index';

export default {
  /**
   * 下载列表
   */
  queryDownloadList(params) {
    return Http.get('/downloadFile/queryDownloads', { params });
  },

  /**
   * 轮询下载列表
   */
  queryDownloadsExclude(params) {
    return Http.get('/downloadFile/queryDownloadsExclude', { params });
  },

  /**
   * 更新下载状态
   * @returns
   */
  updateDownloadFlag(data) {
    return Http.post('/downloadFile/updateDownloadFlag', data);
  },
};
